import { render } from "./UserLabelsMenu.vue?vue&type=template&id=66fa3f2f"
import script from "./UserLabelsMenu.vue?vue&type=script&lang=js"
export * from "./UserLabelsMenu.vue?vue&type=script&lang=js"

import "./UserLabelsMenu.vue?vue&type=style&index=0&id=66fa3f2f&lang=sass"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__